/* Minimal theme JS — vanilla, no deps. */

(function () {
  // Edit overlay — toggles customizable-area annotations
  const editBtn = document.querySelector('[data-edit-toggle]');
  if (editBtn) {
    editBtn.addEventListener('click', () => {
      document.body.classList.toggle('show-edits');
      const on = document.body.classList.contains('show-edits');
      editBtn.textContent = on ? 'Hide editable areas' : 'Show editable areas';
    });
  }

  // Minimap scroll spy
  const dots = document.querySelectorAll('.minimap a');
  if (dots.length) {
    const targets = Array.from(dots).map(d => document.querySelector(d.getAttribute('href')));
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (!e.isIntersecting) return;
        dots.forEach(d => d.classList.remove('is-active'));
        const i = targets.indexOf(e.target);
        if (i >= 0) dots[i].classList.add('is-active');
      });
    }, { rootMargin: '-45% 0px -45% 0px' });
    targets.forEach(t => t && io.observe(t));
  }

  // Product page — option swatch toggling
  document.querySelectorAll('.opt-row').forEach(row => {
    row.addEventListener('click', (e) => {
      const btn = e.target.closest('.opt');
      if (!btn) return;
      row.querySelectorAll('.opt').forEach(o => o.setAttribute('aria-pressed', 'false'));
      btn.setAttribute('aria-pressed', 'true');
    });
  });

  // Gallery — hero/thumb swap
  document.querySelectorAll('.gallery').forEach(g => {
    const heroImg = g.querySelector('.gallery__hero img');
    const thumbs = g.querySelectorAll('.gallery__thumb');
    thumbs.forEach(t => {
      t.addEventListener('click', () => {
        thumbs.forEach(x => x.setAttribute('aria-selected', 'false'));
        t.setAttribute('aria-selected', 'true');
        if (heroImg) {
          const thumbImg = t.querySelector('img');
          if (thumbImg) {
            heroImg.src = thumbImg.src.replace('width=240', 'width=1200');
            heroImg.alt = thumbImg.alt;
          }
        }
      });
    });
  });

  // Qty +/-
  document.querySelectorAll('.qty').forEach(q => {
    const input = q.querySelector('input');
    q.querySelector('[data-qty-dec]')?.addEventListener('click', () => {
      input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
    });
    q.querySelector('[data-qty-inc]')?.addEventListener('click', () => {
      input.value = parseInt(input.value || '1', 10) + 1;
    });
  });

  // Cart count — fake increment on ATC
  const cartCount = document.querySelector('[data-cart-count]');
  document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
    btn.addEventListener('click', () => {
      const old = btn.querySelector('.label')?.textContent || 'Add to cart';
      btn.querySelector('.label').textContent = 'Added — thank you';
      if (cartCount) cartCount.textContent = String(parseInt(cartCount.textContent || '0', 10) + 1);
      setTimeout(() => {
        if (btn.querySelector('.label')) btn.querySelector('.label').textContent = old;
      }, 2000);
    });
  });

  // Accordion (uses <details>, native — no JS needed)
})();
